module.exports = __webpack_public_path__ + "img/ho-chi-minh.e75ac99f.jpg";